import { render, staticRenderFns } from "./BoxBorder.vue?vue&type=template&id=ebf5c268&scoped=true&"
import script from "./BoxBorder.vue?vue&type=script&lang=js&"
export * from "./BoxBorder.vue?vue&type=script&lang=js&"
import style0 from "./BoxBorder.vue?vue&type=style&index=0&id=ebf5c268&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf5c268",
  null
  
)

export default component.exports